<template>
  <div>
    <a-row type="flex">
      <a-col :span="3"></a-col>
      <a-col :span="4" class="concept_page_title">Value</a-col>
      <a-col :span="17"></a-col>
    </a-row>
    <a-row type="flex" justify="center">
      <a-col :span="9" class="concept_page_background1"></a-col>
      <a-col :span="9" class="concept_page_text">
        <div style="padding: 4vh 0">
          <p style="font-size: 18px; font-weight: bolder; ">Investment Philosophy</p>
          <p>————</p>
          <p>SIG endeavors to find companies with unique value propositions. We believe that a truly great business
            starts with a distinctive business idea and stands out for its core values and beliefs. We never stop
            looking for the companies that genuinely solve problems and may change the world in the future. When we find
            such a company, we stay in it for the long-run.</p>
          <br>
          <p>Comprehensive analysis and insights lie at the heart of our investment process, and based on years of
            in-depth assessments of numerous companies in different industries, we are willing to provide our portfolio
            companies with great assistance to accelerate post-investment performance. SIG is dedicated to helping our
            entrepreneurs build successful companies by providing them with capital, guidance, network and the best
            resources available.</p>
          <br>
          <p>We believe that quality founders are the key to success and that great entrepreneurs come from many diverse
            backgrounds and experiences. We look for founders who are courageous and willing to try new ideas and
            methods of developing a business. We know there will be setbacks and value entrepreneurs who learn from
            their failures. Most importantly, we look for founders who are grateful for life experiences and hold no
            grudge for any misfortune, who value competitors and exceeds the excellence of themselves.</p>
        </div>
      </a-col>
    </a-row>
    <a-row type="flex" justify="center">
      <a-col :span="9" class="concept_page_text" style="display: flex; align-items: center">
        <div style="padding: 10vh 0;">
          <p style="font-size: 18px; font-weight: bolder;">Key Investment Sectors</p>
          <p>———</p>
          <p>Over the past 15 years, SIG has focused on technology/media, consumer/modern services, healthcare/green
            technologies. We are interested in new business models, and we pay close attention to technology
            innovations, but most important of all, we value the gift and potential of entrepreneurs.</p>
          <br>
          <p>We invest companies in all stages. Specifically, we look for companies who can provide unique products and
            services in China and global market. And we pay close attention to consumer and media sectors. Also we value
            the management team in startups. As SIG is renowned for its corporate culture to inspire employee to
            challenge their potential, we look for innovative companies which have both strategic vision and strong
            execution.</p>
        </div>
      </a-col>
      <a-col :span="9" class="concept_page_background2"></a-col>
    </a-row>
    <a-row type="flex" justify="center">
      <a-col :span="9" class="concept_page_background3"></a-col>
      <a-col :span="9" class="concept_page_text" style="display: flex; align-items: center">
        <div style="padding: 5vh 0">
          <p style="font-size: 18px; font-weight: bolder;">Our Advantages</p>
          <p>————</p>
          <p>Having obtained ownership interests in over 260 portfolio companies and accompanied them through full
            industry cycles for the past ten years, SIG has accumulated deep insights and extensive knowledge in various
            industries. SIG’s portfolio companies share experiences and resources in operation/strategy/hiring, and
            build business synergies together. Moreover, as an investor throughout Asia we are able to see the trends,
            understand the strengths and needs in each country and are able to assist our portfolio companies in
            identifying and taking advantage of their regional opportunities.</p>
          <br>
          <p>We invest with SIG’s internal capital which means we have no duration limits and have no outside limited
            partners. Therefore, SIG has its natural advantage to exercise an independent investment philosophy and make
            fast and flexible investment decisions, which helps our portfolio companies to concentrate on their business
            growth.</p>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Concept_page',
}
</script>

<style scoped>
.concept_page_title {
  background: #2f54eb;
  color: white;
  font-size: 18px;
  text-align: left;
  line-height: 40px;
  padding-left: 2vh;
  text-indent: 2em;
}

.concept_page_background1 {
  background-image: url("../../../assets/image/concept_page1.jpg");
  background-size: 100% 100%;
}

.concept_page_background2 {
  background-image: url("../../../assets/image/concept_page2.jpg");
  background-size: 100% 100%;
}

.concept_page_background3 {
  background-image: url("../../../assets/image/concept_page3.jpg");
  background-size: 100% 100%;
}

.concept_page_text {
  background: #f3f3f3;
  text-align: left;
}

.concept_page_text p {
  color: black;
  font-size: 14px;
  margin: 0.4vh 3vw;
}
</style>